import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { DataModel } from '../../models/DataModel'

export interface ActivityIndicatorModel {
    type: 'success' | 'error' | 'loading',
    title?: string,
    text?: string,
    text2?: string
}

export interface authSlice {
    activityIndicator: ActivityIndicatorModel | undefined,
    data: DataModel | undefined
}


const initialState: authSlice = {
    activityIndicator: undefined,
    data: undefined
}

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        storeActivityIndicator: (state, action: PayloadAction<ActivityIndicatorModel | undefined>) => {
            state.activityIndicator = action.payload
        },
        storeData: (state, action: PayloadAction<DataModel | undefined>) => {
            state.data = action.payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { storeActivityIndicator, storeData } = authSlice.actions

export default authSlice.reducer;